import { useIntl } from 'react-intl';

import { useAnalysisProfileQuery } from '../api/useAnalysisProfileQuery';
import type { UseAnalysisDetailPageResult } from '../types';
import { useAnalysisRouteParams } from './useAnalysisRouteParams';

export const useAnalysisDetailPage = (): UseAnalysisDetailPageResult => {
  const { formatMessage } = useIntl();

  const { projectId, analysisProfileId, analysisVersionId } = useAnalysisRouteParams();

  const { data: profileEnvelope, isLoading: isProfileLoading } = useAnalysisProfileQuery({
    projectId,
    analysisProfileId,
  });
  const profile = profileEnvelope?.data;

  const pageTitle = profile?.name ?? formatMessage({ id: 'analysisDetail.fallbackTitle' });

  const ownerName = profile?.createdBy
    ? `${profile.createdBy.firstName} ${profile.createdBy.lastName}`.trim()
    : null;

  return {
    projectId,
    analysisProfileId,
    analysisVersionId,
    pageTitle,
    isProfileLoading,
    latestStatus: profile?.latestStatus ?? null,
    isMetaReady: !!profile,
    ownerName,
    lastModifiedDate: profile?.modifiedBy?.transactionDate ?? null,
  };
};
